import { render, staticRenderFns } from "./TraceabilitySampleView.vue?vue&type=template&id=6e5ddf55&scoped=true"
import script from "./TraceabilitySampleView.vue?vue&type=script&lang=js"
export * from "./TraceabilitySampleView.vue?vue&type=script&lang=js"
import style0 from "./TraceabilitySampleView.vue?vue&type=style&index=0&id=6e5ddf55&prod&lang=scss&scoped=true"
import style1 from "./TraceabilitySampleView.vue?vue&type=style&index=1&id=6e5ddf55&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5ddf55",
  null
  
)

export default component.exports